module.exports = __webpack_public_path__ + "img/member_coupons_icon_431005.ed4eb6b3.png";